import { SocketEventType } from '@/modules/core/app/constants/SocketEventType';
import { UserSocketEvent } from '@/modules/core/app/events/UserSocketEvent';

export class NewMessageUserSocketEvent extends UserSocketEvent {
  messageId?: number;
  conversationId?: number;
  isDeleted?: boolean;

  constructor(model: Partial<NewMessageUserSocketEvent> = {}) {
    super(model);

    this.messageId = model.messageId;
    this.conversationId = model.conversationId;
    this.isDeleted = model.isDeleted;
  }

  static getEventName(): string {
    return SocketEventType.NEW_MESSAGE_USER_SOCKET_EVENT;
  }
}
